import { Component } from '@angular/core';
import { SecuredBaseComponent } from '../base/secured-base.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PendingPaymentRequestService } from '../services/pending-payment-request.service';
import { PendingPaymentRequest } from '../models/PendingPaymentRequest';
import { PaginatedList } from '../models/PaginatedList';
import { environment } from '../../environments/environment';
import { Pagination } from '../models/Pagination';
import { ManagerService } from '../services/manager.service';

@Component({
  selector: 'pending-payment-requests',
  templateUrl: 'pending-payment-requests.component.html',
  styleUrls: ['pending-payment-requests.component.css']
})
export class PendingPaymentRequestsComponent extends SecuredBaseComponent {

  constructor(public override snackBar: MatSnackBar, public override router: Router, public override managerService: ManagerService,
    private pendingPaymentRequestService: PendingPaymentRequestService)
  {
    super(snackBar, router, managerService);
  }

  pendingPaymentRequests: PaginatedList<PendingPaymentRequest> = {
    totalCount: 0,
    pageSize: environment.pageSize,
    from: 0,
    entities: [],
    currentPage: 1,
    totalPages: 1,
    to: 0,
    hasPreviousPage: false,
    hasNextPage: false
  };

  requestedPage: number = 1;

  displayedColumns: string[] = ['paymentRequestId', 'date', 'requestedAmount', 'requestedPaymentAmount', 'receivedPaymentAmount', 'netAmount', 'action'];

  override ngOnInit() {
    super.ngOnInit();

    this.search();
  }

  search() {
    this.requestedPage = 1
    this.loadPendingPaymentRequests();
  }

  get pagination() {
    return this.pendingPaymentRequests as Pagination;
  }

  pageChanged(page: number) {
    this.requestedPage = page;
    this.loadPendingPaymentRequests();
  }

  loadPendingPaymentRequests() {
    let criteria = this.buildSearchCriteria();
    this.pendingPaymentRequestService.lookup(this.manager.consumerId, criteria).subscribe(
      result => { this.pendingPaymentRequests = result as PaginatedList<PendingPaymentRequest>; },
      error => { this.showError(error, 'Get pending payment requests has failed due to server error'); }
    );
  }

  buildSearchCriteria() {
    const criteria = {
      since: (this.requestedPage - 1) * this.pendingPaymentRequests.pageSize,
      limit: this.pendingPaymentRequests.pageSize,
      sort: '-CreateDate',
      filter: ''
    };

    return criteria;
  }

  edit(pendingPaymentRequest: PendingPaymentRequest) {
    this.router.navigate(['/main/pending-payment-request', pendingPaymentRequest.id]);
  }
}
